import type { AUTH_ROUTE_PATHS } from "./constants";

export type AuthRouteName = keyof typeof AUTH_ROUTE_PATHS;
export type AuthRoutePath = (typeof AUTH_ROUTE_PATHS)[AuthRouteName];

export type AuthBaseInput =
  | {
      authBasePath: string;
      authPageUrl?: never;
    }
  | {
      authBasePath?: never;
      authPageUrl: string;
    };

export type AuthSearchValue = string | number | boolean | null | undefined;
export type AuthSearch = URLSearchParams | Record<string, AuthSearchValue | readonly AuthSearchValue[]>;

type ResolvePredefinedAuthHrefOptions = {
  predefinedHref: string;
  authBasePath?: never;
  authPageUrl?: never;
  route?: never;
  isAppRouterEnabled?: never;
  pathSegments?: never;
  search?: AuthSearch;
};

type ResolveGeneratedAuthHrefOptions = AuthBaseInput & {
  predefinedHref?: never;
  route: AuthRoutePath;
  isAppRouterEnabled: boolean;
  pathSegments?: readonly string[];
  search?: AuthSearch;
};

/**
 * Options for either a legacy predefined auth href or a generated auth route.
 * The discriminated union prevents callers from combining a predefined URL with
 * route-generation inputs, which are not used when the predefined URL is selected.
 */
export type ResolveAuthHrefOptions = ResolvePredefinedAuthHrefOptions | ResolveGeneratedAuthHrefOptions;
